import React, { useState } from 'react'
import Functions from './functions';
import { APP_VERSION, BUILD_TIME } from '../../../configTools/version';

// Login form, on the new design system (Task 11). Rebuilt directly on labelled inputs,
// reusing the Contact page's .form-field pattern (Task 10) instead of the shared
// src/components/form/primaryinput.jsx and primaryaltbtn.jsx: those render a <label> as a
// plain sibling of the <input> with no htmlFor/id pairing, the task brief requires a real
// association, and src/components/form/* stays unrestyled per the task's constraints.
//
// Submit behaviour is unchanged: Functions.Submit still posts the same {username, password}
// body on the same trigger (a click on Login, or Enter in either field), and functions.js
// (not touched by this task) still owns the fetch call and the localStorage write. The
// password field stays deliberately uncontrolled (no `value` prop) for the same
// DevTools-visibility reason primaryinput.jsx documented.
const Form = () => {
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');

    const submit = () => {
        Functions.Submit({ username, password });
    };

    const onKeyPress = (event) => {
        if(event.key === 'Enter'){
            submit();
        }
    };

    return (
        <div className="login-card">
            <h1 className="login-card-title">Login to continue</h1>
            <div className="login-form">
                <div className="form-field">
                    <label htmlFor="login-username">Username</label>
                    <input
                        id="login-username"
                        type="text"
                        value={username}
                        placeholder="Username"
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyPress={onKeyPress}
                    />
                </div>
                <div className="form-field">
                    <label htmlFor="login-password">Password</label>
                    <input
                        id="login-password"
                        type="password"
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={onKeyPress}
                    />
                </div>
                <button type="button" className="btn-lg login-submit" onClick={submit}>Login</button>
            </div>

            {/* Deliberately readable, not a hidden watermark: this is how a deploy gets
                confirmed at a glance. BUILD_TIME is injected by the build script, so a
                stale bundle is obvious even when APP_VERSION has not moved. */}
            <div className="login-build-badge">
                <span className="login-build-version">v{APP_VERSION}</span>
                <p className="login-build-time">build {BUILD_TIME}</p>
            </div>
        </div>
    )
}

export default Form
